import React, { useEffect, useState } from 'react'
import {
    MDBTable,
    MDBTableBody,
    MDBTableHead,
} from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { getDeviceOnlineStatusInfo, getIPPhoneDevice, getOnlineDevicesStatusForPhones } from '../../../apiclients/streamsapi_bridge';
import { useNavigate } from 'react-router';
function UserIpPhonesDevices(props) {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [ipphonedeviceList, setIPPhoneDeviceList] = useState([]);

    // useEffect(() => {
    //     async function fetchData() {
    //         const response = await getIPPhoneDevice(
    //             JSON.parse(sessionStorage.getItem("admin_session")).siteid,
    //             props.useragent
    //         );
    //         if (!response.json) {
    //             const message = `An error has occured: ${response.statusText}`;
    //             return;
    //         }
    //         const rawData = await response.json();
    //          console.log('ipphone response ::: ' + JSON.stringify(rawData));
    //         setIPPhoneDeviceList(rawData.deviceInfo);
    //         // setDevicesList(proccessdRows);
    //         const devices = rawData.deviceInfo ?? [];
    //         // let macAddresses = devices.map((obj) => obj.macAdress);
    //         let macAddresses = props.userDeviceList.map((obj) => obj.macAdress);
    //         var paramsJo = {
    //             macAddresList: macAddresses,
    //         };

    //         console.log("praramJO:::::::::" + JSON.stringify(paramsJo));

    //         getforOnlineStatus(paramsJo, props.userDeviceList);
    //     }

    //     if (props.useragent) {
    //         fetchData();
    //     }

    // }, [props.useragent]);
    function navigateToIpPhones(item) {
        console.log("navigateToIpPhones :: ", JSON.stringify(item));
        if (item.model == "Manual") {
            navigate("/manualdevicesettings", {
                state: {
                    deviceUUID: item?.deviceuuid, device:JSON.stringify({})
                },
            });
        } else {
            navigate("/ipphoneadd", {
                state: { macAdress: item?.macAdress, device:JSON.stringify({}) },
            });
        }
    }
    useEffect(() => {

        if (props.userDeviceList?.length > 0) {
            const deviceuuid = props.userDeviceList.map((obj) => obj.deviceuuid);
            const paramsJo = {
                devicesList: deviceuuid,
            };
            console.log("praramJO:::::::::" + JSON.stringify(paramsJo));

            getforOnlineStatus(paramsJo);
        }

    }, [])

    async function getforOnlineStatus(paramsJo) {
        const api_response = await getOnlineDevicesStatusForPhones(JSON.parse(sessionStorage.getItem("admin_session")).siteid, paramsJo);
        console.log("api_response ::: " + api_response);
        if (!api_response.ok) {
            console.log("Server response was not ok");
            // throw new Error("Network response was not ok");
        }
        let response = await api_response.json();
        console.log("api_response  " + response);
        var livedataObjectsInfo = response?.deviceStatus;
        console.log("devicesStatus :::::: " + JSON.stringify(livedataObjectsInfo));
        const configured_devices_withstatus = props.userDeviceList.map((data) => {
            const result = livedataObjectsInfo?.find(
                (liveobj) => data?.deviceuuid?.toString() === liveobj?.device_uuid?.toString()
            );
            return result ? { ...data, online: result.online_status } : data;
        })

        console.log("final result is ::::::::::::::::: " + JSON.stringify(configured_devices_withstatus));
        // setIPPhoneDeviceList(configured_devices_withstatus);
        props.setUserDeviceList(configured_devices_withstatus)


    }
    return (
        <>
            <div
                className="general-settings"
                id="PhonesandDevices"
            >
                {t("IP-PhonesandDevices")}
            </div>
            <div style={{ paddingLeft: "10px" }}>
                <MDBTable>
                    <MDBTableHead>
                        <tr>
                            <th scope="col" className="w-30">
                                {t("phoneName")}
                            </th>
                            <th scope="col" className="w-30">
                                {t("Model")}
                            </th>
                            <th scope="col" className="w-30">
                                {t("MACaddress")}
                            </th>
                            <th
                                scope="col"
                                className="w-10 text-center"
                            >
                                {t("Online")}
                            </th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                        {props.userDeviceList && props.userDeviceList.length > 0 && (props.userDeviceList.map((item) => (

                            <tr className="cursor-pointer" onClick={() => navigateToIpPhones(item)}>
                                <td scope="row">{item.phonename}</td>
                                <td>{item.model}</td>
                                <td>{item.macAdress}</td>
                                <td className="text-center">
                                    {/* <div className="d-flex align-items-center justify-content-center">
                                        <div className="green-dot"></div>
                                    </div>           */}
                                    <div className="d-flex align-items-center justify-content-center">
                                        {item.online ? (
                                            <div className="green-dot"></div>
                                        ) : (
                                            <div className="red-dot"></div>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        )))}
                        {(!props.userDeviceList || props.userDeviceList.length == 0) &&
                            (
                                <tr className='border-0 datatable-results-info'>
                                    <td colSpan="4" align="center" className='border-0'>
                                        No records found
                                    </td>
                                </tr>
                            )
                        }


                    </MDBTableBody>
                </MDBTable>
            </div>

        </>
    )
}

export default UserIpPhonesDevices
